import { request } from '../../utils/request';

export type EarningsRange = '7d' | '30d' | '90d' | 'all';

export type StoreEarningsTrendPoint = {
  date: string;
  gross: string;
  net: string;
  orders: number;
};

export type StoreEarnings = {
  // Legacy fields, still populated for the older dashboard cards
  currency: string;
  total: number;
  pending: number;
  available: number;
  pending_orders: number;
  delivered_orders: number;

  // New fields backing the Earnings page
  fee_rate: number; // 0.10 for products
  lifetime_gross: string;
  lifetime_net: string;
  pending_payout: string;
  settled_amount: string;
  range: EarningsRange;
  range_gross: string;
  range_net: string;
  range_orders: number;
  by_day: StoreEarningsTrendPoint[];
};

export const getStoreEarnings = (
  store_id: number,
  authToken: string,
  range?: EarningsRange
): Promise<StoreEarnings> => {
  const params = new URLSearchParams({ store_id: `${store_id}` });
  if (range) params.set('range', range);
  return request({
    method: 'GET',
    url: `/products/earnings?${params.toString()}`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
};
